var _style, _g, _path, _g2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "215.1px",
    height: "48.4px",
    viewBox: "0 0 215.1 48.4",
    style: {
      enableBackground: "new 0 0 215.1 48.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#162040;}\n\t.st1{fill:#F2B631;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,537.7c0-6.2,1.9-11.7,5.6-16.4c3.7-4.8,9.1-8.5,16.1-11.2l0.2-1c-3.3-1.6-5.9-4-7.6-7.1 c-1.7-3.2-2.6-6.7-2.6-10.7c0-4,1.2-7.7,3.7-11.1c2.5-3.4,6-6.3,10.6-8.7c-12.9-7.1-19.3-19-19.3-35.5c0-14.4,4.7-25.1,14.2-32 c9.5-6.9,21.8-10.4,37-10.4c6.2,0,12.3,0.6,18.3,1.9h38.4c2.5,0,4.4,1,5.5,2.9c1.1,1.9,1.7,4.9,1.7,9.1v4.1 c0,7.5-1.9,11.2-5.7,11.2c-1.3,0-3-0.1-5-0.2c-2.1-0.1-3.8-0.4-5.2-0.7l-0.5,1c1.1,1.4,2,3.4,2.7,6.1s1.1,5,1.1,7.3 c0,14.1-4.5,24.7-13.5,31.7c-9,7-20.7,10.5-35.1,10.5c-9.7,0-14.5,2.1-14.5,6.4c0,2.7,1.7,4.6,5,5.6c3.3,1,9.1,2.2,17.2,3.4 c5.7,0.6,10.1,1.3,13.1,1.9c11.3,2.2,20.3,5.8,26.9,10.9c6.7,5,10,12.9,10,23.7c0,8.1-2.5,15.2-7.6,21.3 c-5.1,6.1-12.3,10.9-21.6,14.2c-9.3,3.3-20.1,5-32.3,5C77.1,570.5,58.2,559.6,58.2,537.7z M135.9,539.6c4.1-2.1,6.2-4.9,6.2-8.6 s-2.7-6.3-8-8c-5.3-1.7-14.9-3-28.7-3.9c-4,1.4-7.1,3.3-9.4,5.6c-2.3,2.3-3.4,4.7-3.4,7.3c0,3.3,2,6,6.1,7.9s10.4,2.9,19,2.9 C125.6,542.7,131.8,541.6,135.9,539.6z M129,448.4c3.3-2.8,5-6.9,5-12.5c0-5.7-1.7-10-5-12.8c-3.3-2.8-7.6-4.2-12.9-4.2 c-5.2,0-9.5,1.4-12.9,4.2c-3.3,2.8-5,7-5,12.8c0,5.6,1.7,9.7,5,12.5c3.3,2.8,7.6,4.2,12.9,4.2C121.4,452.6,125.6,451.2,129,448.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.8,512.9V491c0-5.1,4.8-7.6,14.3-7.6h7.6c9.5,0,14.3,2.5,14.3,7.6v21.9c0,5.1-4.8,7.6-14.3,7.6h-7.6 C190.6,520.5,185.8,518,185.8,512.9z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 492,
    height: 575,
    xlinkHref: "4908619D.jpg",
    transform: "matrix(1 0 0 1 267.2222 265.6111)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -35.6712 279.5977)",
    style: {
      fontFamily: "'FranklinGothic-Heavy'",
      fontSize: "64.1229px"
    }
  }, "Galilee"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -21.1526 142.8569)",
    style: {
      fontFamily: "'HelveticaNowDisplay-Blk'",
      fontSize: "64.1229px"
    }
  }, "Galilee"), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.3,21v26.2h-8.7l-1.3-6c-2.9,4.7-8.6,7-14.7,7c-13.3,0-22-9.2-22-23.9S9.3,0.5,24.2,0.5 c12.2,0,21,6.2,22.5,16.6H33.6c-1.2-3.5-4.3-5.6-9.3-5.6c-6.6,0-10.5,4.8-10.5,12.9c0,8.1,4,12.9,11.2,12.9c4.5,0,8.1-2.5,9-6.5 h-8.4V21H47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.1,47.2c-0.4-0.8-0.8-2.1-0.8-3.4c-2.1,2.6-5.6,4.2-10.5,4.2c-6.9,0-12.2-3.6-12.2-10.3 c0-5.9,3.5-9.5,13.2-10.3l5.3-0.4c2.7-0.3,4-1,4-2.8c0-1.5-0.8-2.6-4.2-2.6c-3.3,0-4.6,0.7-4.9,3.5H51.3 c0.6-7.7,5.6-11.7,16.7-11.7c10.8,0,15.6,3.8,15.6,10.4v17.5c0,2.6,0.4,4.7,1.3,6H73.1z M72,34.1v-1.9c-0.6,0.8-1.5,1.1-2.9,1.3 l-3.8,0.4c-2.5,0.3-3.8,1.3-3.8,3.3c0,2,1.6,3.2,4.2,3.2C69.2,40.4,72,38.8,72,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.8,1.5h11.8v45.7H86.8V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.5,14.1h11.8v33.1h-11.8V14.1z M100.9,1.5H112v9.2h-11.1V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.4,1.6h11.8v45.7h-11.8V1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.2,34.1H139c0.8,3.8,3.3,5.6,6.6,5.6c2.8,0,4.7-1,5.8-2.9h11C160.6,44,153.6,48,145.6,48 c-10.7,0-17.8-6.9-17.8-17.3s7-17.3,17.7-17.3c10.5,0,17.8,6.9,17.8,18.6V34.1z M139,27.1h12.9c-0.8-3.6-3.1-5.4-6.5-5.4 C142.2,21.7,139.7,23.3,139,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,34.1H176c0.8,3.8,3.3,5.6,6.6,5.6c2.8,0,4.7-1,5.8-2.9h11C197.6,44,190.7,48,182.6,48 c-10.7,0-17.8-6.9-17.8-17.3s7-17.3,17.7-17.3c10.5,0,17.8,6.9,17.8,18.6V34.1z M176,27.1h12.9c-0.8-3.6-3.1-5.4-6.5-5.4 C179.2,21.7,176.8,23.3,176,27.1z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.8,36.4v11h11.1v-11H202.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.089cd5bcd3be13511b15de093839b67a.svg";
export { ForwardRef as ReactComponent };